export const T = {
  en_GB: {
    matches: "Matched individuals",
    matchesHint:
      "The lists record people by name, date of birth and country — they hold no national ID. Decide which of these, if any, is this client.",
    confirm: "This is them",
    dismiss: "Different person",
    confirmed: "Confirmed",
    dismissed: "Dismissed",
    undecided: "Undecided",
    born: "born",
  },
  nb_NO: {
    matches: "Treff på personer",
    matchesHint:
      "Listene registrerer personer med navn, fødselsdato og land — de inneholder ingen fødselsnummer. Avgjør hvilke av disse, om noen, som er denne kunden.",
    confirm: "Dette er kunden",
    dismiss: "Annen person",
    confirmed: "Bekreftet",
    dismissed: "Avvist",
    undecided: "Ikke avgjort",
    born: "født",
  },
} as const;
